import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IGramam {
gramam_id:number,
gramam_name:string,
upa_mandal_id:number,
seq_no:number,
is_active:boolean
}

interface IGramamData {
    list?: Array<IGramam>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: IGramamData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const gramamSlice = createSlice({
    name: "gramam",
    initialState,
    reducers: {
        setGramamList: (state, _action: PayloadAction<IGramamData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetGramamToInit: (state) => {
            state = initialState;
        },
        setGramamMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setGramamList, resetGramamToInit, setGramamMessage } = gramamSlice.actions;

export default gramamSlice.reducer;

